import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import ContactUs from "./Pages/ContactUs";
import MainLayout from "./MainLayout";
import GameList from "./Pages/GameList";
import Carousal from "../Components/SingleCarousal";
import Personalized from "../Navigation/Pages/Personalized";
import Game from "../Components/Game/GameContainer";
import GameLayout from "./GameRoute";
import Privecy from "./Pages/Privecy";
import TermsOfService from "./Pages/TermsOfService";
import TestGameList from "./Pages/TestGameList";
import TestProfile from "./Pages/TestProfile";
import TestHome from "./Pages/TestHome";

export const router = createBrowserRouter(
  createRoutesFromElements([
    <Route path="/" element={<MainLayout />}>
      <Route index element={<TestHome />} />
      {/* <Route index element={<Carousal />} /> */}
      <Route path="games/" element={<TestGameList />} />
      <Route path="auth/" element={<Personalized />} />
      <Route path="privacy/" element={<Privecy />} />
      <Route path="terms-and-service/" element={<TermsOfService />} />
      <Route path="contact-us/" element={<ContactUs />} />
      <Route path="/" element={<TestHome />} />
      <Route path="profile/" element={<TestProfile />} />
      <Route path="*" element={<Personalized />} />
      {/* <Route path="/test" element={<GameList/>} /> */}
    </Route>,
    <Route path="/" element={<GameLayout />}>
      <Route path="playing/*" element={<Game />} />
      <Route path="*" element={<Personalized />} />
    </Route>,
  ])
);
